// extracted by mini-css-extract-plugin
export var list = "BlogListing-module--list--OXHTu";
export var more = "BlogListing-module--more--Nu7gc";